import type { VitrineAppProps, ProdutosBlackFridayProps, VitrineLandingPageProps, MostruarioEspacadaProps, MostruarioMiniaturaProps, DestaqueMiniaturaProps, DestaqueMiniaturaBlackProps, QuatroItensBlackProps, UmItemDestaqueBlackProps } from './types/vitrineApp.props'
import { ProdutosBlackFriday } from './modelos/ProdutosBlackFriday/ProdutosBlackFriday'
import { tipoVitrine } from './data/tipoVitrine'
import { VitrineLandingPage } from './modelos/VitrineLandingPage/VitrineLandingPage'
import { MostruarioMiniatura } from './modelos/MostruarioMiniatura/MostruarioMiniatura'
import { MostruarioEspacada } from './modelos/MostruarioEspacada/MostruarioEspacada'
import { DestaqueMiniatura } from './modelos/DestaqueMiniatura/DestaqueMiniatura'
import { DestaqueMiniaturaBlack } from './modelos/DestaqueMiniaturaBlack/DestaqueMiniaturaBlack'
import { QuatroItensBlack } from './modelos/QuatroItensBlack/QuatroItensBlack'
import { UmItemDestaqueBlack } from './modelos/UmItemDestaqueBlack/UmItemDestaqueBlack'

export default class VitrineApp {
    constructor(props: VitrineAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return

        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)

        const tipo = Number(props.tipoVitrine)

        switch(tipo) {
            //RenderVitrineTipo2
            case tipoVitrine.PRODUTOS_BLACK_FRIDAY: {
                const {...restProps } = props as ProdutosBlackFridayProps
                root.render(<ProdutosBlackFriday {...restProps} />)
                break
            }

            //RenderVitrineTipo 3
            case tipoVitrine.VITRINE_LANDING_PAGE: {
                const {...restProps } = props as VitrineLandingPageProps
                root.render(<VitrineLandingPage {...restProps} />)
                break
            }

            //RenderVitrineTipo4 e RenderVitrineTipo5
            case tipoVitrine.MOSTRUARIO_OFERTA_LIMITADA_DOIS_PRODUTOS:
            case tipoVitrine.MOSTRUARIO_OFERTA_LIMITADA_TRES_PRODUTOS: {
                const { ...restProps } = props as MostruarioMiniaturaProps

                const vitrineMostruarioClass = tipo === tipoVitrine.MOSTRUARIO_OFERTA_LIMITADA_DOIS_PRODUTOS ? "macro-vitrine-mostruario-oferta-limitada" : "macro-vitrine-mostruario-oferta-limitada-tres-produtos"
                root.render(<MostruarioMiniatura {...restProps} className={vitrineMostruarioClass} />)
                break
            }

            // RenderVitrineTipo6 e RenderVitrineTipo8
            case tipoVitrine.MOSTRUARIO_TRES_LINHA:
            case tipoVitrine.MOSTRUARIO_TRES_LINHA_TIMER: {
                const { ...restProps } = props as MostruarioEspacadaProps

                const vitrineMostruarioClass = tipo === tipoVitrine.MOSTRUARIO_TRES_LINHA_TIMER ? " tres-produtos-timer" : ""
                root.render(<MostruarioEspacada {...restProps} className={vitrineMostruarioClass} />)
                break
            }

            // RenderVitrineTipo9
            case tipoVitrine.UM_DESTAQUE_TRES_MINIATURA: {
                const { ...restProps } = props as DestaqueMiniaturaProps

                root.render(<DestaqueMiniatura {...restProps} />)
                break
            }

            // RenderVitrineTipo10
            case tipoVitrine.UM_DESTAQUE_TRES_MINIATURA_BLACK: {
                const { ...restProps } = props as DestaqueMiniaturaBlackProps

                root.render(<DestaqueMiniaturaBlack {...restProps} />)
                break
            }

            // RenderVitrineTipo11
            case tipoVitrine.QUATRO_ITENS_BLACK: {
                const { ...restProps } = props as QuatroItensBlackProps

                root.render(<QuatroItensBlack {...restProps} />)
                break
            }

            // RenderVitrineTipo12
            case tipoVitrine.UM_ITEM_DESTAQUE_BLACK: {
                const { ...restProps } = props as UmItemDestaqueBlackProps

                root.render(<UmItemDestaqueBlack {...restProps} />)
                break
            }

            default:
                console.warn(`Tipo de vitrine não tratado: ${tipo}`)
        }
    }
}
